import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { FORM_COLUMN_TYPES } from '@cli-constants/schema.js'

export function collectInvalidFormColumnTypeErrors(schema: FormSchema, errors: string[]): void {
  for (const column of schema.columns || []) {
    if (
      column.type !== undefined &&
      (typeof column.type !== 'string' || !FORM_COLUMN_TYPES.has(column.type))
    ) {
      errors.push(
        `Form column "${column.accessorKey || 'unnamed'}" has unsupported type "${String(column.type)}".`
      )
    }
  }
}
